import { createSelector } from 'reselect';
import { getWorkspace } from './workspaceSelectors';

export const getUser = (state) => state.currentUser.user;
export const getUpdateMarkers = (state) => state.currentUser.markers;

export const getUserRole = createSelector(
    getUser,
    getWorkspace,
    (user, workspace) => {
        const obj = user.workspaces.reduce((acc, curr) => {
            acc[curr.workspace] = curr.role;
            return acc;
        }, {});

        return obj[workspace._id];
    }
);
